<app-manage-template
[title]="'Manage Networks'"
(updateParent)="updateTeam($event)" (updateMembers)="updateTeamMembers($event)"
[KEY]="'MANAGE_NETWORKS'" [COLUMNFIELDS]="columns" [holder]="'Search by network name'"
[parentData]="networkDetails"  [userData]="(networkData | async)"
[onSearch]="onSearch" [onFilter]="onFilter" [this]="this"  [ownerView]="true"
[onScroll]="onScroll" [holder]="'Search by network name'">

<div class="row mt-1">
  <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
</div>


</app-manage-template>
